import { Controller } from 'react-hook-form'
import { Input } from 'alurkerja-ui'
import { useContext, useEffect } from 'react'
import { CustomComponentContext, CustomComponentContextType } from '@/utils/contexts/CustomComponentContext'
import { UserService } from '@/api/user'

export default function EmployeeName() {
  const { setValue, control } = useContext<CustomComponentContextType>(CustomComponentContext)
  const { data: userData } = UserService.useGetProfile()

  const classNamesLabel = 'after:text-sm font-medium'

  useEffect(() => {
    if (userData) {
      setValue('EMPLOYEE_NAME', userData.employeeId)
    }
  }, [userData, setValue])

  return (
    <div className="grid space-x-2">
      <div>
        <label htmlFor="employeeName" className={classNamesLabel}>
          Nama Karyawan
        </label>
        <Controller
          name={'employeeName'}
          control={control}
          render={() => {
            return (
              <>
                <Input value={userData?.fullname ?? ''} defaultValue={userData?.fullname ?? ''} disabled />
              </>
            )
          }}
        ></Controller>
      </div>
    </div>
  )
}
